import * as React from "react";
import { IconButtonProps } from "../../types";
import { Button } from "@progress/kendo-react-buttons";

/**
 * Kendo flat icon button wrapper. Renders a Kendo `Button` with icon support,
 * defaulting to `fillMode="flat"` for a minimal appearance.
 *
 * @example
 * ```tsx
 * <IconButton icon="edit" color="primary" onClick={handleEdit} />
 * <IconButton icon="trash" color="error" onClick={handleDelete}>Delete</IconButton>
 * ```
 */
const IconButton: React.FC<IconButtonProps> = ({
  icon,
  color,
  fillMode,
  children,
  onClick,
  style,
}) => {
  fillMode = fillMode ?? "flat";

  return (
    <Button
      icon={icon}
      themeColor={color}
      fillMode={fillMode}
      onClick={onClick}
      style={{ ...style, marginTop: "5px" }}
    >
      {children}
    </Button>
  );
};

export default IconButton;
